import { useCallback, useEffect } from 'react';
import { Loader2 } from 'lucide-react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useSigninMutation } from 'features/auth/hooks/use-auth';
import { useToast } from 'hooks/use-toast';
import { useTranslation } from 'react-i18next';
import { useAuthStore } from 'state/store/auth/useAuthStore';

export function RedirectPage() {
  const navigate = useNavigate();
  const { toast } = useToast();
  const { t } = useTranslation();
  const { mutateAsync } = useSigninMutation();
  const { login } = useAuthStore();
  const [searchParams] = useSearchParams();

  const signin = useCallback(
    async (code: string, state: string) => {
      const res = await mutateAsync({ grantType: 'social', code, state });
      login(res.access_token, res.refresh_token);
      // Check if there's a goto parameter in the URL
      const gotoParam = searchParams.get('goto');
      if (gotoParam) {
        navigate(gotoParam);
      } else {
        navigate('/home');
      }
      toast({
        variant: 'success',
        title: t('SUCCESS'),
        description: t('LOGIN_SUCCESSFULLY'),
      });
    },
    [login, mutateAsync, navigate, searchParams, t, toast]
  );

  useEffect(() => {
    const state = searchParams.get('state');
    const code = searchParams.get('code');
    if (code && state) {
      signin(code, state);
    }
  }, [searchParams, signin]);

  return (
    <div className="inset-0 z-50 flex flex-col items-center justify-center bg-background/80 backdrop-blur-sm">
      <Loader2 className="h-8 w-8 animate-spin text-primary" />
      <h2 className="text-2xl font-bold text-high-emphasis">Redirecting...</h2>
    </div>
  );
}
